import "./Pagination.css";
import PropTypes from "prop-types";

function Pagination(props) {
  // Update search results with courses on the previous page of searched-up courses
  function handlePrev() {
    props.navRetrieved(props.links.prev);
  }

  // Update search results with courses on the next page of searched-up courses
  function handleNext() {
    props.navRetrieved(props.links.next);
  }

  // Update search results with courses on the first page of searched-up courses
  function handleFirst() {
    props.navRetrieved(props.links.first);
  }

  // Update search results with courses on the last page of searched-up courses
  function handleLast() {
    props.navRetrieved(props.links.last);
  }

  return props.pagination && props.numRetrieved && props.pagination.total < 11 ? (
    <div />
  ) : (props.pagination && props.numRetrieved && props.pagination.page === 1 ? (
    <div className="pagination-grid">
      <button disabled>{props.pagination.page}</button>
      <button onClick={handleNext}>&raquo;</button>
      <button onClick={handleLast}>{props.pagination.last}</button>
    </div>
  ) : (props.pagination && props.numRetrieved && props.pagination.page === 2 && props.pagination.last > 3 ? (
    <div className="pagination-grid">
      <button onClick={handleFirst}>1</button>
      <button disabled>{props.pagination.page}</button>
      <button onClick={handleNext}>&raquo;</button>
      <button onClick={handleLast}>{props.pagination.last}</button>
    </div>
  ): (props.pagination && props.numRetrieved && props.pagination.page === props.pagination.last - 1 ? (
    <div className="pagination-grid">
      <button onClick={handleFirst}>1</button>
      <button onClick={handlePrev}>&laquo;</button>
      <button disabled>{props.pagination.page}</button>
      <button onClick={handleLast}>{props.pagination.last}</button>
    </div>
  ) : (props.pagination && props.numRetrieved && props.pagination.page === props.pagination.last ? (
    <div className="pagination-grid">
      <button onClick={handleFirst}>1</button>
      <button onClick={handlePrev}>&laquo;</button>
      <button disabled>{props.pagination.page}</button>
    </div>
  ) : (props.pagination && props.numRetrieved ? (
    <div className="pagination-grid">
      <button onClick={handleFirst}>1</button>
      <button onClick={handlePrev}>&laquo;</button>
      <button disabled>{props.pagination.page}</button>
      <button onClick={handleNext}>&raquo;</button>
      <button onClick={handleLast}>{props.pagination.last}</button>
    </div>
  ) : <div />)))));
}

export default Pagination;

Pagination.propTypes = {
  numRetrieved: PropTypes.number.isRequired,
  pagination: PropTypes.object,
  links: PropTypes.object,
  navRetrieved: PropTypes.func.isRequired,
}
